
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/Input.html",
      function () {
        return require("private-next-pages/Forms/Input.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/Input.html"])
      });
    }
  